// @flow
import React from 'react';
import ReactDOM from 'react-dom';
import { fromJS } from 'immutable';
import CasClient from '@wh/auth-client-component';
import { render } from '@wh/site-base-app-container';
import { init } from '@wh/data-provider';
import { subscribe, publish } from '@wh/message-bus';
import { reducers as ModalReducers } from '@wh/modal-component';
import { reducers as LoginReducers, sagas as LoginSagas } from '@wh/login-component';
import LoginWrapper from '../login-wrapper';
import saga from '../sagas';
import {
    MESSAGE_SUB_INIT_CUST,
    MESSAGE_PUB_USER_NOT_LOGGED_IN,
    MESSAGE_PUB_USER_LOGGED_IN,
} from '../constants';

const defaultConfig: { [key: string]: * } = {
    casUrl: '',
    squizUrl: '',
    service: '',
    modalClassName: '',
    overlayClassName: '',
    loginClassName: '',
    targetId: '',
    modalName: '',
    language: 'en',
    translations: {},
};

/**
 * Login Integration Component
 * Creates methods for external Login Form Modal usage (non-npm environment)
 */
export default class LoginIntegration {
    config: Object;

    constructor({ config = defaultConfig }: Object) {
        this.config = config;

        subscribe(MESSAGE_SUB_INIT_CUST, (topic, data) => this.initCust(data));
    }

    initCust(data: Object) {
        const custLogin = data.custLogin || false;
        const casClient = new CasClient(this.config.casUrl, this.config.service);
        // Defining accepted language as ql forces CAS to provide message codes instead of messages.
        casClient.setAcceptedLanguage('ql');

        casClient.init(true, custLogin).then((casData: Object) => {
            publish(MESSAGE_PUB_USER_LOGGED_IN, casData);
        }).catch(() => {
            publish(MESSAGE_PUB_USER_NOT_LOGGED_IN, {});
        });
    }

    /**
     * Destroys mounted modal
     * @returns {Function} this - LoginIntegration
     */
    destroy() {
        if (this.config.targetId) {
            ReactDOM.unmountComponentAtNode(document.getElementById(this.config.targetId));
        }
    }

    /**
     * Mounts new login component
     * @returns {Function} this - LoginIntegration
     */
    init() {
        const {
            squizUrl,
            targetId,
            language,
        } = this.config;

        if (squizUrl) {
            init({
                squiz: {
                    baseUrl: squizUrl,
                },
            });
        }

        if (!targetId) {
            const id = 'wh-login-component';
            const div = document.createElement('div');

            div.setAttribute('id', id);
            document.body.appendChild(div);
            this.config.targetId = id;
        }

        const initialState = fromJS({
            settings: { language },
        });

        const reducers = {
            ...LoginReducers,
            ...ModalReducers,
        };

        const sagas = [saga, ...LoginSagas];

        const App = () => (
            <LoginWrapper {...this.config} />
        );

        render({
            App,
            initialState,
            reducers,
            sagas,
            targetId: this.config.targetId,
        });
    }
}



// WEBPACK FOOTER //
// ./src/main/login-integration/login-integration.js